import React from "react";
import useFetch from "../hooks/useFetch";
import AnimatedContent from "./animation/AnimatedContent";
import { noWidow } from "../js/typography";

export default function WeSection() {
  const weFetch = useFetch(`${window.$host}/api/we?populate=*`);
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1099px)").matches;


  const MaybeAnimate = ({ enabled, children, ...props }) =>
    enabled ? <AnimatedContent {...props}>{children}</AnimatedContent> : children;

  if (weFetch.loading) return;
  if (weFetch.error) return;

  return (
    <section className="about" id="about">
      <div className="container">
        <div className="h-100 content-box">
          <div className="about__box">
            <MaybeAnimate enabled={!isMobile} delay={0.10}>
              <h2 className="title-3 about__title">
                {noWidow(weFetch.data.data.Title)}{" "}
                <span className="text-blue">{noWidow(weFetch.data.data.TitleBlue)}</span>
              </h2>
            </MaybeAnimate>

            <MaybeAnimate enabled={!isMobile} delay={0.40}>
              <ul className="about__list">
                {weFetch.data.data.List.map((item) => (
                  <li key={item.id} className="about-card">
                    <span className="text-20 text-gray about-card__title">
                      {noWidow(item.Title)}
                    </span>
                    <p className="text-20 about-card__text">{noWidow(item.Text)}</p>
                  </li>
                ))}
              </ul>
            </MaybeAnimate>
          </div>
        </div>
      </div>
    </section>
  );
}
